import { render, staticRenderFns } from "./GroupEdit.vue?vue&type=template&id=3e7236d7&scoped=true"
import script from "./GroupEdit.vue?vue&type=script&lang=ts"
export * from "./GroupEdit.vue?vue&type=script&lang=ts"
import style0 from "./GroupEdit.vue?vue&type=style&index=0&id=3e7236d7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e7236d7",
  null
  
)

export default component.exports